import PyramidChart from './PyramidChart';

export default PyramidChart;
